import { QueryKey, UseQueryOptions, useMutation, useQuery } from "@tanstack/react-query";
import { baseService } from "./baseService";

interface BaseQueryProps<T = any> {
  endpoint: string;
  queryKey?: QueryKey;
  options?: Omit<UseQueryOptions<T, Error, T, QueryKey>, 'queryKey' | 'queryFn'>;
}

export const useBaseQuery = <T>({ endpoint, queryKey, options }: BaseQueryProps<T>) => {

  if (!queryKey) {
    queryKey = [endpoint];
  }

  return useQuery<T>({
    queryKey: queryKey,
    queryFn: async () => {
      try {
        //console.log("useBaseQuery", endpoint);
        if (!endpoint || endpoint.trim() === "") {
          throw new Error("Endpoint cannot be empty");
        }
        var result = await baseService.getAll<T>(endpoint);
        return result;
      } catch (error: any) {
        //console.log("useBaseQuery " + endpoint, error);
        //window.location.href = "/login";
        throw new Error(error);
      }
    },
    ...options,
  });
};

interface BaseMutationProps {
  mutationKey?: QueryKey;
  endpoint: string;
  data?: any;
  method: "POST" | "PUT" | "DELETE";
}

export const useBaseMutation = <T>({
  mutationKey,
  endpoint,
  data,
  method,
}: BaseMutationProps) => {

  if (!mutationKey) {
    mutationKey = [endpoint];
  }

  return useMutation<T>({
    mutationKey: mutationKey,
    mutationFn: async () => {
      try {
        var response = null;
        switch (method) {
          case "POST":
            response = await baseService.add<T>(endpoint, data);
            break;
          case "PUT":
            response = await baseService.update<T>(endpoint, data);
            break;
          case "DELETE":
            response = await baseService.delete<T>(endpoint, data);
            break;
          default:
            throw new Error("Method not found");
        }

        return response;

      } catch (error: any) {
        console.log(`useMutation ${endpoint}`, error);
        throw new Error(error);
      }
    },
  });
};

// Yeni hook - mutate'e parametre geçirmeyi destekler
export const useBaseMutationWithVariables = <T, TVariables = any>({
  mutationKey,
  endpoint,
  method,
}: Omit<BaseMutationProps, 'data'>) => {

  if (!mutationKey) {
    mutationKey = [endpoint];
  }

  return useMutation<T, Error, TVariables>({
    mutationKey: mutationKey,
    mutationFn: async (variables: TVariables) => {
      try {
        var response = null;
        switch (method) {
          case "POST":
            response = await baseService.add<T>(endpoint, variables);
            break;
          case "PUT":
            response = await baseService.update<T>(endpoint, variables);
            break;
          case "DELETE":
            response = await baseService.delete<T>(endpoint, variables as any);
            break;
          default:
            throw new Error("Method not found");
        }

        return response;

      } catch (error: any) {
        console.log(`useMutation ${endpoint}`, error);
        throw new Error(error);
      }
    },
  });
};

